// extracted by mini-css-extract-plugin
module.exports = {"marks":"Marks_marks__xgEwF","mark":"Marks_mark__2EiGl","isSystemMark":"Marks_isSystemMark__1Udok","isInterestsMark":"Marks_isInterestsMark__3pUw6"};